import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Logoimg from "../images/logo.png"
import $ from 'jquery'

export default function Signin() {
  const navigate = useNavigate();
  const [alertMsg, setAlertMsg] = useState('');
  const [showAlertBox, setShowAlertBox] = useState(false);
  function loginUser() {
    let user_email = document.getElementById('uemail').value;
    let user_pass = document.getElementById('upass').value;
    if (user_email == '') {
      document.getElementById('uemail').classList.add('highlight_box')
    } else if (user_pass == '') {
      document.getElementById('upass').classList.add('highlight_box')
    } else {
      var obj = {
        username: user_email,
        pass: user_pass,
      }
      $.ajax({
        type: 'POST',
        url: 'user.php',
        data: obj,
        cache: false,
        success: function (result) {
          console.log(result)
          if (result.trim() != 'fail') {
            var arr = result.split('|');
            var firstname = arr[0].trim();
            var lastname = arr[1].trim();
            var membername = firstname + ' ' + lastname;
            var emailval = arr[2];
            var LUID = arr[3];
            var mem_position = arr[4];
            var mem_permission = arr[5];
            var mem_company_name = arr[6];
            var mem_company_id = arr[7];
            var mem_profile_img = arr[8];
            var mem_company_logo = arr[9];
            var user_block = arr[10];
            var delete_user = arr[11]
            if (user_block == 'yes') {
              showAlert('Sorry, you cannot signin right now. Please contact with administrator for further information.')
            }else if(delete_user=='yes'){
                showAlert('Sorry, we cannot find any record.')
            } else {
              localStorage.setItem('member_id', LUID);
              localStorage.setItem('memberFirstname', firstname);
              localStorage.setItem('membername', membername);
              localStorage.setItem('useremail', emailval);
              localStorage.setItem('mem_permission', mem_permission);
              localStorage.setItem('user_position', mem_position);
              localStorage.setItem('mem_company_name', mem_company_name);
              localStorage.setItem('mem_company_id', mem_company_id);
              localStorage.setItem('memberimg', mem_profile_img);
              localStorage.setItem('companylogo', mem_company_logo);
              addLoghrecord(membername, emailval, mem_position, mem_company_id)
              //navigate('/dashboard');
            }
          } else {
            alert('Cannot login. Please try once again.')
          }

        },
      });
    }
  }

  function addLoghrecord(membername, emailval, mem_position, mem_company_id) {
    const now = new Date();
    const datetoday = now.toLocaleDateString(); // Date only
    const timenow = now.toLocaleTimeString(); // Time only
    const formData = new FormData();
    formData.append('membername', membername);
    formData.append('emailval', emailval);
    formData.append('com_id', mem_company_id);
    formData.append('mem_position', mem_position);
    formData.append('login_date', datetoday);
    formData.append('login_time', timenow);
    // 👆 make sure memberId exists (from session / JS variable)

    fetch('insertLogoinRecord.php', {
      method: 'POST',
      body: formData
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === 'success') {
          getPermission(mem_company_id)
          //navigate('/dashboard');
        } else {
          showAlert(data.message);
        }
      })
      .catch(err => {
        console.error(err);
        showAlert("Login record saving failed");
      });
  }

  function getPermission(mem_company_id) {
    $.ajax({
      type: 'POST',
      url: 'getUserPermissions.php',
      success: function (response) {
        console.log(response);
        //const data = JSON.parse(response);
        const data = response;

        if (data.status === 'success') {
          localStorage.setItem(
            'user_permissions',
            JSON.stringify(data.permissions)
          );
           //navigate('/dashboard');
         getMembershipData(mem_company_id)
        } else {
          showAlert('Not loged in yet.')
        }
      }
    });
  }

  function getMembershipData(com_id){
    var obj={
      comid:com_id
    }
    console.log(obj)
    $.ajax({
        type: 'POST',
        url: 'getrMembershiptype.php',
        data: obj,
        cache: false,
        success: function (result) {
          console.log(result)
          if (result.trim() != 'fail') {
            var arr = result.split('|');
            var currency = arr[0].trim();
            var max_member = arr[1].trim();
            var membership_status = arr[2];
            var membership_type = arr[3];
            var prev_type = arr[4];
              localStorage.setItem('member_currency', currency);
              localStorage.setItem('membership_type', membership_type);
              localStorage.setItem('max_member', max_member);
              localStorage.setItem('membership_status', membership_status);
              localStorage.setItem('prevmembership_type', prev_type);
             
              navigate('/dashboard');
          } else {
            alert('Cannot login. Please try once again.')
          }

        },
      });
  }
  const showAlert = (msg) => {
    setAlertMsg(msg);
    setShowAlertBox(true);
  };

  const closeAlert = () => {
    setShowAlertBox(false);
    setAlertMsg('');
  };
  return (
    <div>
      <div className="signinbody signinback">
        <div className="signinbox">
          <div className="logoholder">
            <Link to=""><img src={Logoimg} alt="Logo" /></Link>
          </div>
          <div className="logbox logheight">
            
           
            <h3> Sign In With Email</h3>

            <div className="formfieldbox">
              <input type="email" id="uemail" placeholder="Your Email" />
            </div>
            <div className="formfieldbox">
              <input type="password" id="upass" placeholder="Your Password" />
            </div>
            <div className="formbtnbox">
              <input type="button" id="sub" value="Sign in" onClick={loginUser} />
            </div>
            <p>Forgot your password? <Link to="/forgotpass">Click Here</Link></p>
            <p>Don't have an account? <Link to="/signup">Create now</Link></p>


          </div>
         
        </div>
      </div>
      {showAlertBox && (
        <div className='vl_dsh_popup activebillpop'>
          <div className='alertbox'>
            <div className='alertheader'>
              <h3><i className='ri-alert-line'></i>Alert</h3>
            </div>

            <div className='contentarea'>
              <p>{alertMsg}</p>
            </div>

            <div className='alert_btns'>
              <button onClick={closeAlert}>Okay</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
